import React, { Component } from 'react';
import tryMe from '../../../helpers/tryMe';
import AvatarUploader from '../../AvatarUploader/AvatarUploader';
import AuthButton from '../../../containers/Forms/AuthButton';
import SlateTextInput from '../../Shared/SlateTextInput';
import { avatarShapes } from '../../../config/constants';

export default class FormUserProfile extends Component {
  UNSAFE_componentWillMount() {
    const { currentUser } = this.props;
    let edit = this.props.type === 'edit';

    this.props.actions.setFormState({
      name: edit ? currentUser.name : '',
      displayName: edit ? currentUser.displayName : '',
      contactInfo: {
        phone: edit ? currentUser.contactInfo.phone : '',
        email: edit ? currentUser.contactInfo.email : '',
      },
      password: {
        password: '',
        confirmPassword: '',
      },
      imageUUID: edit ? currentUser.imageUUID : '',
      attachments: [],
      dataErrors: {},
    });
  }

  showContactInfoError = () =>
    tryMe(this.props.state.dataErrors).contactInfo &&
    !this.props.state.contactInfo.email &&
    !this.props.state.contactInfo.phone;

  render() {
    const { actions, state, t, type, formError } = this.props;
    const dataErrors = tryMe(state.dataErrors);

    return (
      <form onKeyPress={actions.handleKeyPress}>
        <AvatarUploader
          onAddAttachment={actions.handleAddAttachment}
          type={type}
          t={t}
          shape={avatarShapes.CIRCLE}
        />

        <div
          className={this.showContactInfoError() ? 'form-field-group form-field-group--error' : 'form-field-group'}
          style={{ marginBottom: 16 }}
        >
          <div style={{ marginBottom: 16 }}>
            <SlateTextInput
              name="contactInfo.email"
              type="email"
              label={t('userProfile:email')}
              value={tryMe(state.contactInfo).email || ''}
              onChange={actions.handleChange}
              onBlur={actions.handleBlur}
              autoComplete="email"
              error={dataErrors['contactInfo.email']}
              fullWidth
            />
          </div>

          <div style={{ marginBottom: 8 }}>
            <SlateTextInput
              name="contactInfo.phone"
              type="tel"
              label={t('userProfile:phone')}
              value={tryMe(state.contactInfo).phone || ''}
              onChange={actions.handlePhoneChange}
              onBlur={actions.handleBlur}
              autoComplete="tel-national"
              error={dataErrors['contactInfo.phone']}
              hint="For non-US numbers, include country code"
              fullWidth
            />
          </div>

          {this.showContactInfoError() && (
            <div className="slate-text-input-error">
              {state.dataErrors.contactInfo}
            </div>
          )}
        </div>

        <div style={{ marginBottom: 16 }}>
          <SlateTextInput
            name="name"
            type="text"
            label={t('userProfile:name')}
            value={tryMe(state).name || ''}
            onChange={actions.handleChange}
            onBlur={actions.handleBlur}
            autoComplete="name"
            error={dataErrors.name}
            fullWidth
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <SlateTextInput
            name="displayName"
            type="text"
            label={t('userProfile:displayName')}
            value={tryMe(state).displayName || ''}
            onChange={actions.handleChange}
            onBlur={actions.handleBlur}
            error={dataErrors.displayName}
            hint={t('userProfile:displayNameHint')}
            fullWidth
          />
        </div>

        <div style={{ marginBottom: 16, marginTop: 30 }}>
          <SlateTextInput
            name="password.password"
            type="password"
            label={t('userProfile:password')}
            value={tryMe(state.password).password || ''}
            onChange={actions.handleChange}
            onBlur={actions.handleBlur}
            autoComplete="new-password"
            error={dataErrors['password.password']}
            fullWidth
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <SlateTextInput
            name="password.confirmPassword"
            type="password"
            label={t('userProfile:confirmPassword')}
            value={tryMe(state.password).confirmPassword || ''}
            onChange={actions.handleChange}
            onBlur={actions.handleBlur}
            autoComplete="new-password"
            error={dataErrors['password.confirmPassword']}
            fullWidth
          />
        </div>

        <AuthButton
          onClick={actions.handleSubmit}
          entityName={state.entityName}
        >
          {t('userProfile:createProfile')}
        </AuthButton>

        {formError && (
          <div className="auth-form-error">
            {formError}
          </div>
        )}
      </form>
    );
  }
}
